import { getSerializer } from '@shared/serializers/serializer';

export const emails = {
  type: 'email',
  attributes: [
    'type',
    'subject',
    'title',
    'body',
    'template',
    'cta',
    'url',
    'createdAt',
    'updatedAt',
    'sendDate',
    'isCheckboxSelected',
    'isReplyCheckboxSelected',
    'attachments',
    'to',
    'replyTo'
  ]
  
};

export const EmailsSerializer = getSerializer(emails);
